module.exports = __webpack_public_path__ + "img/Menu-03.19045542.png";